import {UserTagModel} from "./user-tag.model";
import {FolderModel} from "./folder.model";
import {Type} from "class-transformer";

export class FoldersAndTagsModel {
  @Type(() => UserTagModel)
  tags: UserTagModel[];
  @Type(() => FolderModel)
  folders: FolderModel[];
  @Type(() => UserTagModel)
  tag: UserTagModel;
  @Type(() => FolderModel)
  folder: FolderModel;
}
